import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM13.01 12.12L16.64 15.23L15.34 16.75L11.02 13.04V5.99H13.02V12.12H13.01Z" fill={ fill || 'currentColor' } />
    </svg>

);
